import {
  FolderList,
  FolderItem,
  RecentChatItem,
  RecentChats,
  CommunityWrapper,
  CommunityItem,
  CommunityFlag,
  CommunityInfo,
  CommunityName,
  CommunityMembers,
} from "./styled";
import { ReactComponent as AddIcon } from "../../assets/add.svg";
import { ReactComponent as RecentIcon } from "../../assets/recent.svg";
import { ReactComponent as SettingIcon } from "../../assets/setting.svg";
import { ReactComponent as LogoutIcon } from "../../assets/logout.svg";
import { ReactComponent as CalendarIcon } from "../../assets/calendar.svg";
import { ReactComponent as ProfileIcon } from "../../assets/user.svg";
import { ReactComponent as QAIcon } from "../../assets/qa.svg";
import defaultAvatar from "../../assets/default_avatar.png";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { getHistoryThunk } from "../../store/actions/chat.action";
import { useTopic } from "../../context/topicContext";
import { topics } from "../../constants/topics";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../store/actions/auth.action";
import { Tooltip, Dropdown } from "antd";
import { listCommunities } from "../../constants/communities";
import nFormatter from "../../core/utils/n-formatter";
import { useSocialContext } from "../../context/socialContext";

interface Props {
  openSidebar: boolean;
  closeAfterClicked?: boolean;
  setOpenSidebar: (value: React.SetStateAction<boolean>) => void;
}

const HomeSidebarContent = ({ closeAfterClicked, setOpenSidebar }: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const communities = listCommunities.map((community) => ({
    ...community,
    // members: nFormatter(stats?.stats?.post?.[community.countryCode] || 0, 1),
  }));

  const features = [
    {
      name: "Chat with AI",
      expandDisable: false,
      func: () => {
        navigate(`/chat`);
      },
    },
    {
      name: "Booking Hotel",
      expandDisable: false,
      func: () => {
        navigate(`/booking`);
      },
    },
  ];
  const { recentsChat } = useAppSelector((state) => state.chatReducer);
  const { topic, setTopic } = useTopic();
  const { community: selectedCommunity, setSelectedCommunity } =
    useSocialContext();

  const fecthRecentSearch = async () => {
    if (!topic) return;

    try {
      await dispatch(getHistoryThunk()).unwrap();
    } catch (e) {}
  };

  const handleCommunityClick = (countryCode: string) => {
    setSelectedCommunity(countryCode);
    setOpenSidebar(false);
    navigate("/");
  };

  const handleAction = useCallback(
    (action: any) => {
      if (!closeAfterClicked) {
        action?.();
        return;
      }

      action?.();
    },
    [closeAfterClicked]
  );

  useEffect(() => {
    if (location.pathname.includes("/chat")) {
      fecthRecentSearch();
    }
  }, [topic, location.pathname]);

  return (
    <FolderList>
      {features.map((folder, index) => (
        <Tooltip key={index} title={folder.name} placement="right">
          <FolderItem
            onClick={() => {
              handleAction(() => folder.func());
              if (closeAfterClicked) {
                setOpenSidebar(false);
              }
            }}
          >
            {folder.name}
          </FolderItem>
        </Tooltip>
      ))}
      <div
        style={{
          gap: "8px",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            color: "#a1a1aa",
            fontSize: "14px",
          }}
        >
          Communities
        </div>
        <CommunityWrapper>
          {communities.map((community, index) => (
            <CommunityItem
              key={index}
              isSelected={selectedCommunity === community.countryCode}
              onClick={() => handleCommunityClick(community.countryCode)}
            >
              <CommunityFlag>
                {community.countryCode === "KARDO" ? (
                  <img
                    src={community.flag}
                    alt={community.name}
                    style={{
                      width: "100%",
                      objectFit: "cover",
                      padding: "4px",
                      boxSizing: "border-box",
                    }}
                  />
                ) : (
                  community.flag
                )}
              </CommunityFlag>
              <CommunityInfo>
                <CommunityName>{community.name}</CommunityName>
                {/* <CommunityMembers>{community.members} posts</CommunityMembers> */}
              </CommunityInfo>
            </CommunityItem>
          ))}
        </CommunityWrapper>
      </div>
    </FolderList>
  );
};

export default HomeSidebarContent;
